export class Vehiculo {
    public idVehiculo: any;
    public nombreVehiculo: string;
    public tipoPermisoID : any;
    public tipoPermiso : any;
    public numeroPermiso : any;
    public configuracionVeicularID: any;
    public configuracionVeicular: any;
    public placa: any;
    public modelo: any;
    public poliza: number;
    public aseguradora: any;
    public pesoBruto: number;
    
    loacs?: string;
    
    public idvehiculo: number;
    }


// WEBPACK FOOTER //
// ./src/app/models/vehiculo.ts